import React, { useEffect, useState } from "react";
import "./Quiz.css"; // Include the updated CSS file
import Bg_Photo from "../../assets/images/bbblurry.png";

const Quiz = () => {
  const [quizData, setQuizData] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [score, setScore] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [topic, setTopic] = useState(""); // Input for user to specify topic
  const [language, setLanguage] = useState("EN"); // Default language is English

  // class Confettiful {
  //   constructor(el) {
  //     this.el = el;
  //     this.containerEl = null;

  //     this.confettiFrequency = 3;
  //     this.confettiColors = [
  //       "#EF2964",
  //       "#00C09D",
  //       "#2D87B0",
  //       "#48485E",
  //       "#EFFF1D",
  //     ];
  //     this.confettiAnimations = ["slow", "medium", "fast"];

  //     this._setupElements();
  //     this._renderConfetti();
  //   }

  //   _setupElements() {
  //     const containerEl = document.createElement("div");
  //     const elPosition = this.el.style.position;

  //     if (elPosition !== "relative" || elPosition !== "absolute") {
  //       this.el.style.position = "relative";
  //     }

  //     containerEl.classList.add("confetti-container");
  //     this.el.appendChild(containerEl);
  //     this.containerEl = containerEl;
  //   }

  //   _renderConfetti() {
  //     this.confettiInterval = setInterval(() => {
  //       const confettiEl = document.createElement("div");
  //       const confettiSize = Math.floor(Math.random() * 3 + 7) + "px";
  //       const confettiBackground =
  //         this.confettiColors[
  //           Math.floor(Math.random() * this.confettiColors.length)
  //         ];
  //       const confettiLeft =
  //         Math.floor(Math.random() * this.el.offsetWidth) + "px";
  //       const confettiAnimation =
  //         this.confettiAnimations[
  //           Math.floor(Math.random() * this.confettiAnimations.length)
  //         ];

  //       confettiEl.classList.add(
  //         "confetti",
  //         "confetti--animation-" + confettiAnimation
  //       );
  //       confettiEl.style.left = confettiLeft;
  //       confettiEl.style.width = confettiSize;
  //       confettiEl.style.height = confettiSize;
  //       confettiEl.style.backgroundColor = confettiBackground;

  //       confettiEl.removeTimeout = setTimeout(() => {
  //         confettiEl.parentNode.removeChild(confettiEl);
  //       }, 3000);

  //       this.containerEl.appendChild(confettiEl);
  //     }, 25);
  //   }
  // }

  // useEffect(() => {
  //   // Trigger confetti animation only when quiz is completed
  //   if (currentQuestion >= quizData.length && quizData.length > 0) {
  //     const containerEl = document.querySelector(".js-container");
  //     if (containerEl) {
  //       new Confettiful(containerEl);
  //     }
  //   }
  // }, [currentQuestion, quizData.length]);

  const cleanJSON = (text) => {
    const start = text.indexOf("{");
    const end = text.lastIndexOf("}");
    return text.substring(start, end + 1);
  };

  const fetchData = async (topic, language = "EN") => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `https://api.notesmania.in/quiz-api.php?topic=${encodeURIComponent(
          topic
        )}&language=${encodeURIComponent(language)}`
      );
      const text = await response.text();
      const jsonString = cleanJSON(text);
      const data = JSON.parse(jsonString);
      setQuizData(data.questions || []); // Default to an empty array if questions are not found
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
      setError("Failed to fetch or parse data.");
    } finally {
      setLoading(false);
    }
  };

  const handleAnswerSelect = (option) => {
    setSelectedOption(option);

    // Check if the selected option is correct or not
    if (option === quizData[currentQuestion].answer) {
      setScore((prev) => prev + 1);
      setFeedback("correct");
    } else {
      setFeedback("wrong");
    }
  };

  const handleNextQuestion = () => {
    // Move to the next question and reset states
    setSelectedOption(null);
    setFeedback(null);
    setCurrentQuestion((prev) => prev + 1);
  };

  const handleStartQuiz = () => {
    if (topic.trim()) {
      setQuizData([]);
      setScore(0);
      setCurrentQuestion(0);
      fetchData(topic);
    }
  };

  if (loading)
    return (
      <div>
        <div className="main-loading">
          <div className="spacecraft-loading">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
            <div className="orbit"></div>
          </div>
        </div>
      </div>
    );
  if (error) return <div>Error: {error}</div>;

  // Check if the current question exists in the quizData array
  const question = quizData[currentQuestion];

  // Show summary if the last question is answered
  if (!question && currentQuestion >= quizData.length && quizData.length > 0) {
    return (
      <div
        className="quiz-summary"
        style={{
          backgroundImage: `url(${Bg_Photo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="js-container container-main"
          style={{ top: "0px" }}
        ></div>{" "}
        {/* Confetti container */}
        <div className="checkmark-circle">
          <div className="background">
            {" "}
            <img src="https://cdn3.emoji.gg/emojis/44245-snowman.gif" alt="" />
          </div>
        </div>
        <div className="quiz-text-div">
          <h2 className="quiz-summary-title">Quiz Completed</h2>
          <p>
            Your Score: {score} / {quizData.length}
          </p>
          <button className="quiz-btn" onClick={() => window.location.reload()}>
            Play Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="quiz-app"
      style={{
        backgroundImage: `url(${Bg_Photo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {quizData.length === 0 && !loading && (
        <div className="quiz-setup-container">
          <h1 className="quiz-app-title">Welcome to the Quiz App</h1>
          <p className="quiz-app-description">
            Choose a topic and start your quiz adventure. Select your preferred
            language too!
          </p>

          <div className="quiz-setup">
            <input
              type="text"
              className="quiz-input"
              placeholder="Enter a topic for your quiz"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
            />
            <select
              className="language-selector"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="EN">English</option>
              <option value="HI">Hindi</option>
             
            </select>
            <button
              className="quiz-btn start-btn"
              onClick={() => fetchData(topic, language)}
              disabled={!topic.trim()}
            >
              Start Quiz
            </button>
          </div>

          <h2 className="quiz-section-title">Popular Quizzes</h2>
          <div className="quiz-cards">
            {[
              { name: "Movies Quiz", icon: "🎥" },
              { name: "Games Quiz", icon: "🎮" },
              { name: "Science Quiz", icon: "🔬" },
            ].map((quiz) => (
              <div
                key={quiz.name}
                className="quiz-card-chip"
                onClick={() => fetchData(quiz.name, language)}
              >
                <div className="quiz-card-content">
                  <span className="quiz-card-icon">{quiz.icon}</span>
                  <h3>{quiz.name}</h3>
                  <p>Explore {quiz.name} now!</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {loading && (
        <p className="loading-message">Loading your quiz... Please wait.</p>
      )}

      {quizData.length > 0 && !loading && (
        <div className="quiz-card">
          <header className="quiz-header">
            <h3 className="quiz-title">Interactive Quiz</h3>
            <p className="quiz-progress">
              Question {currentQuestion + 1} of {quizData.length}
            </p>
          </header>

          <div className="quiz-question-container">
            <p className="quiz-question">
              {quizData[currentQuestion]?.question || "No question available"}
            </p>
          </div>

          <div className="quiz-options-container">
            {quizData[currentQuestion]?.options.map((option, index) => (
              <div
                key={index}
                className={`quiz-option ${
                  selectedOption === option
                    ? feedback === "correct"
                      ? "quiz-option-correct"
                      : "quiz-option-wrong"
                    : feedback === "wrong" &&
                      option === quizData[currentQuestion]?.answer
                    ? "quiz-option-correct"
                    : ""
                }`}
                onClick={() => !selectedOption && handleAnswerSelect(option)}
              >
                {/* <span className="quiz-option-letter">
                  {String.fromCharCode(65 + index)}.
                </span> */}
                {option}
              </div>
            ))}
          </div>

          <div className="quiz-footer">
            <button
              className={`quiz-btn next-btn ${
                !selectedOption ? "quiz-btn-disabled" : ""
              }`}
              disabled={!selectedOption}
              onClick={handleNextQuestion}
            >
              {currentQuestion === quizData.length - 1 ? "Finish" : "Next"}
            </button>
          </div>
        </div>
      )}

      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default Quiz;
